import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import HeroSection from './components/HeroSection';
import CategorySection from './components/CategorySection';
import ArticleSection from './components/ArticleSection';
import StatsSection from './components/StatsSection';
import FAQSection from './components/FAQSection';
import CTASection from './components/CTASection';

export default function Home() {
  const location = useLocation();

  useEffect(() => {
    if (location.hash === '#categories-section') {
      const el = document.getElementById('categories-section');
      if (el) el.scrollIntoView({ behavior: 'smooth' });
    }
  }, [location.hash]);

  return (
    <>
      <Navbar />
      <main>
        <HeroSection />
        <CategorySection />
        <ArticleSection />
        <StatsSection />
        <FAQSection />
        <CTASection />
      </main>
      <Footer />

      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{
          __html: JSON.stringify({
            '@context': 'https://schema.org',
            '@type': 'WebPage',
            name: '开云体育 - 官方体育赛事平台',
            description: '开云体育是专业体育赛事平台，提供足球、篮球、网球等多项体育赛事实时资讯、赛程直播与竞技数据分析。',
            url: 'https://www.kaiyunsports.com/',
            isPartOf: {
              '@type': 'WebSite',
              name: '开云体育',
              url: 'https://www.kaiyunsports.com',
            },
            breadcrumb: {
              '@type': 'BreadcrumbList',
              itemListElement: [
                {
                  '@type': 'ListItem',
                  position: 1,
                  name: '首页',
                  item: 'https://www.kaiyunsports.com/',
                },
              ],
            },
          }),
        }}
      />
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{
          __html: JSON.stringify({
            '@context': 'https://schema.org',
            '@type': 'FAQPage',
            mainEntity: [
              {
                '@type': 'Question',
                name: '开云体育平台提供哪些体育赛事资讯？',
                acceptedAnswer: {
                  '@type': 'Answer',
                  text: '开云体育平台覆盖足球、篮球、网球、电竞、赛车等全球30多项热门体育赛事，提供实时比分、赛程安排、赛果查询、专业数据分析及深度赛事报道。',
                },
              },
              {
                '@type': 'Question',
                name: '如何在开云体育平台查看赛事直播？',
                acceptedAnswer: {
                  '@type': 'Answer',
                  text: '在开云体育平台，您可以通过赛事分类页面选择您关注的体育项目，进入对应分类后即可查看正在进行的赛事直播信息。',
                },
              },
              {
                '@type': 'Question',
                name: '开云体育的资讯更新频率如何？',
                acceptedAnswer: {
                  '@type': 'Answer',
                  text: '开云体育的编辑团队实行7×24小时轮值制度，确保全球各大体育赛事的最新动态能够在第一时间呈现在平台上。',
                },
              },
              {
                '@type': 'Question',
                name: '开云体育平台是否免费使用？',
                acceptedAnswer: {
                  '@type': 'Answer',
                  text: '是的，开云体育平台的基础赛事资讯服务完全免费。您可以在平台浏览所有赛事资讯、查看实时比分和赛程安排。',
                },
              },
              {
                '@type': 'Question',
                name: '如何联系开云体育客服？',
                acceptedAnswer: {
                  '@type': 'Answer',
                  text: '您可以通过发送邮件至 service@kaiyunsports.com，或拨打客服热线 400-888-9999 联系我们的客服团队。服务时间为周一至周日 9:00 - 21:00。',
                },
              },
            ],
          }),
        }}
      />
    </>
  );
}